import type { Translations } from "../types";

const it: Translations = {
  "meta.title": "Mappa dei clic per Paese",
  "meta.description":
    "Mappa del mondo interattiva: clic gratuiti per Paese oltre al supporto a pagamento tramite Stripe, PayPal e Buy Me a Coffee.",

  "app.title": "Mappa dei clic per Paese",

  "map.intro":
    "Fai clic su un Paese sulla mappa per dargli un voto gratuito, oppure inviagli supporto economico - entrambi contano per la classifica combinata qui sotto. La mappa riflette solo il supporto all'interno di questa app, non la reale ricchezza nazionale o il PIL.",
  "map.verifying": "Verifica in corso …",
  "map.confirmNotRobot": "Prima di poter aggiungere clic gratuiti, conferma rapidamente che non sei un robot:",
  "map.tryAgain": "Riprova",
  "map.registeringClick": "Registrazione del clic …",
  "map.selectedCountry": "Paese selezionato: {name}.",
  "map.selectFirstFeedback": "Paese selezionato. Per aggiungere un clic gratuito, conferma prima qui sotto che non sei un robot.",
  "map.verificationExpired": "La verifica è scaduta - conferma di nuovo che non sei un robot.",
  "map.slowDown": "Un po' più piano - attendi un momento prima del prossimo clic.",
  "map.clickFailed": "Impossibile registrare il clic. Riprova.",
  "map.clickErrorGeneric": "Errore durante la registrazione del clic.",
  "map.leaderboardHeading": "Classifica dei Paesi",
  "map.emptySelection": "Seleziona un Paese sulla mappa per votarlo o supportarlo.",
  "map.loadingData": "Caricamento dati …",

  "worldmap.loadError": "Impossibile caricare la mappa.",
  "worldmap.resetZoom": "Reimposta zoom",
  "worldmap.resetButton": "⤾ Reimposta",
  "worldmap.loadingMap": "Caricamento mappa …",
  "worldmap.unknownCountry": "Sconosciuto",
  "worldmap.ariaClicks": "{name}: {clicks} clic",
  "worldmap.tooltipClicks": "{clicks} clic",

  "legend.fewer": "Meno clic",
  "legend.more": "Più clic",

  "list.empty": "Ancora nessun clic. Sii il primo!",
  "list.ariaLabel": "Classifica dei Paesi per clic",

  "human.siteKeyMissing": "VITE_TURNSTILE_SITE_KEY non è impostata - consulta il README per la configurazione.",
  "human.verificationFailedGeneric": "Verifica non riuscita.",
  "human.networkError":
    "Impossibile raggiungere la verifica (errore di rete) - controlla VITE_SUPABASE_URL, che verify-human sia distribuita, e ALLOWED_ORIGIN; consulta README/NAVODILA.",
  "human.verificationFailedRetry": "Verifica non riuscita, riprova.",

  "provider.stripe": "💳 Carta (Stripe)",
  "provider.paypal": "🅿️ PayPal",
  "provider.buymeacoffee": "☕ Buy Me a Coffee",

  "panel.selectedCountryLabel": "Paese selezionato",
  "panel.currentlyRanked": "Attualmente in posizione #{rank}",
  "panel.shareCopied": "Copiato ✓",
  "panel.shareShared": "Condiviso ✓",
  "panel.shareButton": "🔗 Condividi",

  "panel.tableClicks": "Clic",
  "panel.tableFree": "Gratuiti",
  "panel.tablePaid": "A pagamento",
  "panel.rowAllTime": "Totale complessivo",
  "panel.rowThisYear": "Quest'anno",
  "panel.rowThisWeek": "Questa settimana",
  "panel.rowToday": "Oggi",

  "panel.totalCombined": "Totale combinato:",
  "panel.totalSupport": "Supporto totale:",

  "panel.paymentMethod": "Metodo di pagamento",
  "panel.noPaymentMethod": "Al momento non è disponibile alcun metodo di pagamento.",
  "panel.supportAmount": "Importo del supporto (EUR)",
  "panel.amountRange": "L'importo deve essere compreso tra {min} e {max}.",
  "panel.quickAmount": "{eur} €",
  "panel.estimatedClicks": "Clic a pagamento stimati:",
  "panel.ratioInfo":
    "Rapporto: {a} = {b} clic (es. {c} = {d} clic). Questa è solo una stima prima del pagamento - il conteggio finale dei clic viene sempre calcolato e confermato dal server in base al pagamento effettivamente confermato.",
  "panel.preparing": "Preparazione …",
  "panel.continueWith": "Continua con {provider}",
  "panel.choosePaymentMethod": "Scegli un metodo di pagamento",
  "panel.bmcUsernameMissing": "VITE_BMC_USERNAME non è impostata - consulta il README per la configurazione.",
  "panel.paypalClientIdMissing": "VITE_PAYPAL_CLIENT_ID non è impostata - consulta il README per la configurazione.",

  "panel.paypalAmountInfo": "Importo: {amount} (stimati {clicks} clic). Completa il pagamento con il pulsante PayPal qui sotto.",
  "panel.back": "← Indietro",

  "panel.bmcWarningTitle": "⚠️ Prima di continuare su BuyMeCoffee:",
  "panel.bmcWarningBody":
    "Incolla il codice qui sotto nel campo messaggio/nota al momento del pagamento — è l'unico modo per sapere quale Paese stai supportando. Senza il codice non possiamo attribuire il pagamento a nessun Paese.",
  "panel.copy": "Copia",
  "panel.copied": "Copiato ✓",
  "panel.suggestedAmount": "Importo suggerito:",
  "panel.bmcAmountNote":
    "(stimati {clicks} clic). BuyMeCoffee purtroppo non supporta il trasferimento dell'importo tramite link — inseriscilo o selezionalo tu stesso sul loro sito. Il numero effettivo di clic viene sempre calcolato in base all'importo che invii realmente su BuyMeCoffee, non da questa stima.",
  "panel.openBmc": "Apri BuyMeCoffee e continua →",
  "panel.waitingProvider": "In attesa della conferma di pagamento dal fornitore di pagamento …",
  "panel.waitingConfirmation": "In attesa della conferma di pagamento …",
  "panel.timedOut":
    "La verifica è scaduta per timeout. Se hai completato il pagamento, la mappa si aggiornerà non appena il server riceverà la conferma - a volte può richiedere un po' più di tempo.",
  "panel.checkAgain": "Controlla di nuovo",

  "panel.cancelled": "Il pagamento è stato annullato o non è andato a buon fine. La mappa non è cambiata.",
  "panel.tryAgain": "Riprova",

  "panel.confirmed": "✅ Supporto confermato!",
  "panel.confirmedBody": "{country} ha ricevuto {clicks} clic a pagamento per {amount}.",

  "panel.errorPreparingSupport": "Errore nella preparazione del tuo supporto.",
  "panel.errorPreparingPayment": "Errore nella preparazione del pagamento.",
  "panel.errorConfirmingPayment": "Errore nella conferma del pagamento.",
  "panel.errorPayingPaypal": "Errore nel pagamento con PayPal.",

  "share.unranked": "{flag}{country} ha bisogno del tuo supporto sulla mappa del mondo!\nAiutalo a scalare la classifica 👇",
  "share.rank1": "{flag}{country} è attualmente al #1!\nAiutaci a restare in cima 👇",
  "share.rankN": "{flag}{country} è attualmente al #{rank}!\nAiutaci ad arrivare al #1 👇",

  "language.switcherLabel": "Lingua",
};

export default it;
